import { ref, watch, onMounted, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import MenuService from '~/services/MenuService';
import type { MenuItem } from '~/services/MenuService';
import { useRouter } from 'vue-router';

export function useMenu() {
  const { locale, t } = useI18n();
  const router = useRouter();
  const menuService = MenuService.getInstance();
  
  const menuItems = ref<MenuItem[]>([]);
  const isLoading = ref<boolean>(false);
  const error = ref<string | null>(null);
  
  /**
   * Backend'den menü öğelerini yükler
   */
  const loadMenuItems = async () => {
    isLoading.value = true;
    error.value = null;
    
    try {
      console.log(`Menü verisi yükleniyor. Dil: ${locale.value}`);
      const response = await menuService.getMenuItems({ lang: locale.value });
      const isSuccess = 
        response.status === true || 
        String(response.status) === "true" || 
        String(response.status) === "success" || 
        (typeof response.status === 'number' && response.status >= 200 && response.status < 300);
      
      if (isSuccess) {
        menuItems.value = response.data || [];
        console.log(`Menü verisi yüklendi: ${menuItems.value.length} öğe`);
      } else {
        error.value = t('errors.menuLoadFailed');
        console.error('Menü verileri yüklenemedi:', response);
      }
    } catch (err) {
      error.value = t('errors.menuLoadError');
      console.error('Menü yükleme hatası:', err);
    } finally {
      isLoading.value = false;
    }
  };
  
  // Dil değiştiğinde menüyü anında yeniden yükle
  watch(() => locale.value, (newLocale, oldLocale) => {
    console.log(`Dil değişti: ${oldLocale} -> ${newLocale}`);
    menuItems.value = []; // Menüyü önce temizle
    loadMenuItems(); // Sonra yeniden yükle
  }, { immediate: true });
  
  // Route değiştiğinde menüyü kontrol et
  watch(() => router.currentRoute.value.fullPath, (newPath) => {
    // Yeni path'den dil bilgisini çıkaralım
    const pathParts = newPath.split('/');
    const possibleLang = pathParts[1]; // İlk segment dil kodu olabilir
    
    // Eğer route'dan gelen dil varsa (en) ve mevcut locale bu değilse
    if (possibleLang === 'en' && locale.value !== 'en') {
      console.log(`EN route algılandı, locale: ${locale.value}, yeniden yükleniyor`);
      menuItems.value = []; // Menüyü önce temizle
      loadMenuItems(); // Sonra yeniden yükle
    }
    
    // Varsayılan dil rotası ve locale varsa
    if (possibleLang !== 'en' && locale.value !== 'tr') {
      console.log(`TR route algılandı, locale: ${locale.value}, yeniden yükleniyor`);
      menuItems.value = []; // Menüyü önce temizle
      loadMenuItems(); // Sonra yeniden yükle
    }
  });
  
  return {
    menuItems,
    isLoading,
    error,
    loadMenuItems
  };
} 